import React from 'react';
import { DecoratorNode } from 'lexical';

import LatexRenderer from '../../../latex/renderer/LatexRenderer';

// Same as LatexNode but without color
export default class SimpleLatexNode extends DecoratorNode<React.JSX.Element> {
    __latex: string;

    constructor(latex: string, key?: string) {
        super(key);
        this.__latex = latex;
    }

    static getType(): string {
        return 'simpleLatex';
    }

    static clone(node: SimpleLatexNode): SimpleLatexNode {
        return new SimpleLatexNode(node.__latex, node.__key);
    }

    exportJSON() {
        return {
            type: 'simpleLatex',
            version: 1,
            latex: this.__latex,
        };
    }

    static importJSON(serialized: any): SimpleLatexNode {
        return new SimpleLatexNode(serialized.latex);
    }

    createDOM(): HTMLElement {
        return document.createElement('span');
    }

    updateDOM(): boolean {
        return false;
    }

    decorate(): React.JSX.Element {
        return React.createElement(LatexRenderer, {
            latex: this.__latex,
        });
    }
}
